import { TEX } from "../core/keys"

export interface MiscAssetSpec {
  textureKey: string
  assetPath: string
}

export const MISC_ASSETS: MiscAssetSpec[] = [
  { textureKey: TEX.APP_ICON, assetPath: "favicon-64x64.webp" },
  { textureKey: TEX.PLANET_EARTH, assetPath: "fx/void/earth-like.webp" },
  { textureKey: TEX.ASTEROID_BASE, assetPath: "fx/void/asteroid-base.webp" },
  { textureKey: TEX.BUMPER_SLINGSHOT, assetPath: "fx/bumper/slingshot.png" },
]
